import "./styles/main.scss";

import Vue from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import store from "./store";
import router from "./router";
import "./plugins";
import "./components";
import "./api";
import "./data";
import "./filters";

import "vue-select/dist/vue-select.css";

Vue.config.productionTip = false;

const app = new Vue({
  vuetify,
  store,
  router,
  render: h => h(App)
}).$mount("#app");

export default app;
